import { Record, List } from 'immutable';
import VocabularyResult from './VocabularyResult';

const VocabularyRecord = Record({
  unitId: undefined,
  studentVocabularyResults: undefined,
});

class Vocabulary extends VocabularyRecord { }

const reviver = ([key, item]) => {
  if (! item) return [key, item];
  switch (key) {
    case 'unitId':
      return [key, `${item}`];
    case 'studentVocabularyResults':
      return [key, new List(item.map((vocabulary) =>
        VocabularyResult.create(vocabulary)))];
    default:
      return [key, item];
  }
};

Vocabulary.create = (data) => new Vocabulary(data).mapEntries(reviver);

export default Vocabulary;



// WEBPACK FOOTER //
// ./data/Vocabulary/model.js